import BaseRoute from "utils/base_route";

// Registration disabled
// import SignupContainer from "./containers/signup";

export default class extends BaseRoute {
  constructor(store) {
    super("signup", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }

  onEnter(state, replace) {
    replace("/login");
  }

  // getComponents(location, cb) {
  //   cb(null, {main: SignupContainer});
  // }
}
